export interface EducationalInstitution {
  name: string;
  locations: string[];
  url: string;
}

export const institutions: EducationalInstitution[] = [
  {
    name: "University of Nicosia (UNIC)",
    locations: ["Nicosia"],
    url: "https://www.unic.ac.cy/",
  },
  {
    name: "European University Cyprus (EUC)",
    locations: ["Nicosia"],
    url: "https://euc.ac.cy/en/",
  },
  {
    name: "Frederick University",
    locations: ["Nicosia", "Limassol"],
    url: "https://www.frederick.ac.cy/en",
  },
  {
    name: "University of Central Lancashire Cyprus (UCLAN)",
    locations: ["Larnaca"],
    url: "https://www.uclancyprus.ac.cy/",
  },
  {
    name: "Uni of Limassol (UOL)",
    locations: ["Nicosia", "Limassol"],
    url: "https://www.uol.ac.cy/",
  },
  {
    name: "Neapolis University Pafos (NUP)",
    locations: ["Pafos"],
    url: "http://www.nup.ac.cy/",
  },
  {
    name: "CTL EuroCollege",
    locations: ["Limassol"],
    url: "http://www.ctleuro.ac.cy/en/",
  },
  {
    name: "Ledra College",
    locations: ["Nicosia"],
    url: "https://ledra.ac.cy/",
  },
  {
    name: "Mesoyios College",
    locations: ["Limassol"],
    url: "https://www.mesoyios.ac.cy/",
  },
  {
    name: "CDA College",
    locations: ["Larnaca", "Limassol", "Nicosia", "Paphos"],
    url: "https://www.cdacollege.ac.cy/",
  },
  {
    name: "InterNapa College",
    locations: ["Famagusta"],
    url: "https://internapa.ac.cy/",
  },
];
